"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWithinGoToPeriod = isWithinGoToPeriod;
var _moment = _interopRequireDefault(require("moment"));
var GOTO_CAMPAIGN_DEADLINE = '31-01-2021';
var PAYMENT_SOURCE = 'checkout';
function isWithinGoToPeriod(folio, source) {
  if (source !== PAYMENT_SOURCE) return false;
  if ((folio === null || folio === void 0 ? void 0 : folio.bookingTotal) !== (folio === null || folio === void 0 ? void 0 : folio.depositTotal)) return false;
  if (typeof (folio === null || folio === void 0 ? void 0 : folio.arrivalDate) !== 'string') return false;
  var checkInDate = (0, _moment["default"])(folio === null || folio === void 0 ? void 0 : folio.arrivalDate);
  var gotoDeadline = (0, _moment["default"])(GOTO_CAMPAIGN_DEADLINE, 'DD/MM/YYYY');
  return !checkInDate.isAfter(gotoDeadline);
}